import SendBookingConfirmationCta from './SendBookingConfirmationCta';

export default SendBookingConfirmationCta;
